import * as React from 'react';
import { useTheme } from '../../theme';
import cn from 'classnames';
import { ArrowBack } from '../../Icons';
var TicketExample = function () {
    var css = useTheme('TicketExample').TicketExample;
    return (React.createElement("div", { className: css.ticketExample },
        React.createElement("div", { className: css.ticketExample__leftSide },
            React.createElement("div", { className: css.ticketExample__header }, "E-Ticket"),
            React.createElement("div", { className: css.ticketExample__flightInfo },
                React.createElement("div", { className: css.ticketExample__content },
                    React.createElement("div", { className: css.ticketExample__passengerName },
                        React.createElement("div", null, "Alex"),
                        React.createElement("div", { className: css.allocated },
                            "Brown ",
                            React.createElement("div", { className: css.icon }, ArrowBack))),
                    React.createElement("div", { className: css.ticketExample__contentGroupItems },
                        React.createElement("div", { className: css.ticketExample__contentItem },
                            React.createElement("div", { className: css.ticketExample__contentItemLabel }, "\u2116 Passport"),
                            React.createElement("div", { className: css.ticketExample__contentItemValue }, "0123456789")),
                        React.createElement("div", { className: cn(css.ticketExample__contentItem, css.allocated) },
                            React.createElement("div", { className: css.ticketExample__contentItemLabel }, "\u2116 Reservation"),
                            React.createElement("div", { className: css.ticketExample__contentItemValue }, "2T7L5M"),
                            React.createElement("div", { className: css.icon }, ArrowBack)))))),
        React.createElement("div", { className: css.ticketExample__rightSide },
            React.createElement("div", { className: css.ticketExample__header },
                React.createElement("div", { className: css.ticketExample__headerAgent },
                    "Agent ",
                    React.createElement("span", null, "TKP")),
                React.createElement("div", { className: css.ticketExample__headerContacts },
                    React.createElement("span", null, "www.airlines-site.com"),
                    React.createElement("span", null, "+7 800 567 00 80"))),
            React.createElement("div", { className: css.ticketExample__flightInfo },
                React.createElement("div", { className: css.ticketExample__content },
                    React.createElement("div", { className: cn(css.ticketExample__contentItem, css.allocated) },
                        React.createElement("div", { className: css.ticketExample__contentItemLabel }, "\u2116 Ticket"),
                        React.createElement("div", { className: css.ticketExample__contentItemValue }, "0123 4567 8901 2345"),
                        React.createElement("div", { className: css.icon }, ArrowBack)),
                    React.createElement("div", { className: css.ticketExample__contentItem },
                        React.createElement("div", { className: css.ticketExample__contentItemLabel }, "Date of sale"),
                        React.createElement("div", { className: css.ticketExample__contentItemValue }, "28 Sep. 2023")),
                    React.createElement("div", { className: css.ticketExample__contentItem },
                        React.createElement("div", { className: css.ticketExample__contentItemLabel }, "\u2116 Loyalty program card"),
                        React.createElement("div", { className: css.ticketExample__contentItemValue }, "0123 4567 8901 2345")))),
            React.createElement("div", { className: css.ticketExample__paymentInfo },
                "Form of payment ",
                React.createElement("span", null, "CCVIXXXXXXXXXXXX5574")))));
};
export default TicketExample;
